import React from "react";
import withProviders from "../../hooks/withProviders";
import { ClientSetAccountsGrid, ClientSetNavbar, ClientSetPageHeader } from "./components";
import { ClientSetProvider } from "./hooks/ClientSetContext";

const ClientSetManagement = () => {
    return <React.Fragment>
        <ClientSetPageHeader />
        <ClientSetNavbar />
        <section className="p-3">
            <ClientSetAccountsGrid />
        </section>
    </React.Fragment>
}

export default withProviders(ClientSetProvider)(ClientSetManagement);